import axios from './_nestAxios'

export const obtenerAsEmisor = params =>
  axios.get('/facturaciones-historial', {
    params: {
      ...params,
      tipoConsulta: 'emisor'
    }
  })

export const obtenerAsEmisorResumen = params =>
  axios.get('/facturaciones-historial', {
    params: {
      ...params,
      tipoConsulta: 'emisor-resumen'
    }
  })

export const obtenerAsEmisorResumenSoloProcesadas = params =>
  axios.get('/facturaciones-historial', {
    params: {
      ...params,
      tipoConsulta: 'emisor-resumen-solo-procesadas'
    }
  })

export const obtenerAsEmisorResumenNotas = params =>
  axios.get('/facturaciones-historial', {
    params: {
      ...params,
      tipoConsulta: 'emisor-resumen-notas'
    }
  })

export const obtenerPrimerPendienteEmisor = () =>
  axios.get('/facturaciones-historial/primer-pendiente', {
    params: {
      tipoConsulta: 'emisor'
    }
  })

  export const obtenerFechaPrimerPendienteEmisorComprobantesElectronicos = () =>
    axios.get('/facturaciones-historial/fecha-primer-pendiente')

export const obtenerPrimerPendienteResumen = () =>
  axios.get('/facturaciones-historial/primer-pendiente', {
    params: {
      tipoConsulta: 'resumen'
    }
  })

export const obtenerPrimerPendienteResumenNotas = () =>
  axios.get('/facturaciones-historial/primer-pendiente', {
    params: {
      tipoConsulta: 'resumen-notas'
    }
  })

export const obtenerHistorialxSocio = (params) => axios.get('/facturaciones-historial/historial-socio', { params: params })

export const consultaSunatxId = id => axios.get(`/facturaciones-historial/${id}/consulta-sunat`)

export const enviarCorreosFaltantes = data => axios.post('/facturaciones-historial/enviar-correos-faltantes', data)

export const enviarCorreoXmlxId = id =>
  axios.post(`/facturaciones-historial/${id}/enviar-correo`, {}, { params: { tipoEnvio: 'xml' } })

export const actualizarCdrxId = id => axios.post(`/facturaciones-historial/${id}/actualizar-cdr`)

export const enviarCorreoXmlCdrxId = id =>
  axios.post(`/facturaciones-historial/${id}/enviar-correo`, {}, { params: { tipoEnvio: 'xml-cdr' } })

export const descargarCdrxId = id =>
  axios.post(`/facturaciones-historial/${id}/descargar-cdr`, {}, { responseType: 'blob' })

export const descargarXmlPrevioxId = id =>
  axios.post(`/facturaciones-historial/${id}/descargar-xml-previo`, {}, { responseType: 'blob' })

export const enviarDocumentosxIds = data => axios.post('/facturaciones-historial/enviar-documentos', data)

export const enviarDocumentosxIdsAsResumen = ids =>
  axios.post('/facturaciones-historial/enviar-resumen-diario', { ids })

export const enviarDocumentosxIdsAsResumenNotas = ids =>
  axios.post('/facturaciones-historial/enviar-resumen-diario-notas', { ids })

export const enviarDocumentosxIdsAsResumenBajas = ids =>
  axios.post('/facturaciones-historial/enviar-resumen-diario-bajas', { ids })

export const darDeBajaxId = id => axios.post(`/facturaciones-historial/${id}/dar-de-baja`)

export const anularxId = id => axios.post(`/facturaciones-historial/${id}/anular`)

export const descargaMasiva = data =>
  axios.get('/facturaciones-historial/descargaMasiva', { responseType: 'blob', params: data })

export const descargarInformeExcel = data =>
  axios.get('/facturaciones-historial/descargarInforme', { responseType: 'blob', params: data })
